module.exports = __webpack_public_path__ + "img/miran.45258082.jpg";